/**
 * Notches Markets pillar - placeholder for the upcoming Market Commentary
 * product. Renders inside the Notches/Trade AI shell so users granted
 * `notches.markets` early can see what they're waiting for.
 */
import React from 'react';
import { Navigation } from '../Navigation';
import { Link } from 'react-router-dom';

const c = {
  bg: '#0f172a', card: '#1f2937', border: '#374151',
  text: '#f9fafb', muted: '#9ca3af', dim: '#6b7280',
  blue: '#3b82f6', green: '#22c55e', amber: '#f59e0b',
};

export const MarketsComingSoon: React.FC = () => (
  <div className="dashboard-container" style={{ background: c.bg, minHeight: '100vh', color: c.text }}>
    <Navigation />
    <div style={{ padding: '24px 32px', maxWidth: 900, margin: '0 auto' }}>
      <div style={{ fontSize: 12, marginBottom: 10 }}>
        <Link to="/notches/dashboard" style={{ color: c.muted, textDecoration: 'none' }}>Notches</Link>
        <span style={{ color: c.dim, margin: '0 6px' }}>/</span>
        <span style={{ color: c.text }}>Markets</span>
      </div>

      <div style={{
        display: 'flex', alignItems: 'center', gap: 12,
        marginBottom: 6, paddingBottom: 10,
        borderBottom: `2px solid ${c.blue}`,
      }}>
        <span style={{ width: 8, height: 28, borderRadius: 2, background: c.blue }} />
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700 }}>Markets</h1>
      </div>

      <Link to="/markets/test-results" style={{
        display: 'block', textDecoration: 'none', color: 'inherit',
        background: c.card, border: `1px solid ${c.border}`,
        borderLeft: `3px solid ${c.green}`,
        borderRadius: 8, padding: 20, marginTop: 24,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>Research Quality Study — July 2026</h2>
          <span style={{ color: c.green, fontSize: 12, fontWeight: 600 }}>NEW &rsaquo;</span>
        </div>
        <p style={{ color: c.muted, fontSize: 14, lineHeight: 1.6, margin: '8px 0 0' }}>
          How we tested our ES / SPX / CL picks against real market history,
          what we found, and what changed as a result.
        </p>
      </Link>

      <Link to="/markets/postmortem" style={{
        display: 'block', textDecoration: 'none', color: 'inherit',
        background: c.card, border: `1px solid ${c.border}`,
        borderLeft: `3px solid ${c.amber}`,
        borderRadius: 8, padding: 20, marginTop: 14,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>What Notches picks did in the market</h2>
          <span style={{ color: c.amber, fontSize: 12, fontWeight: 600 }}>POSTMORTEM &rsaquo;</span>
        </div>
        <p style={{ color: c.muted, fontSize: 14, lineHeight: 1.6, margin: '8px 0 0' }}>
          Every top-3 pick from a two-week window, walked hour-by-hour
          against the option chain. 94% hit a green mark; the median
          best-exit was $296 per contract.
        </p>
      </Link>

      <div style={{
        background: c.card, border: `1px solid ${c.border}`,
        borderLeft: `3px solid ${c.blue}`,
        borderRadius: 8, padding: 24, marginTop: 24,
      }}>
        <h2 style={{ margin: '0 0 8px', fontSize: 18 }}>Daily morning research + voice notes from the WFS desk</h2>
        <p style={{ color: c.muted, fontSize: 14, lineHeight: 1.6, margin: '12px 0' }}>
          Plain-English daily reads on what moved + what to watch. Not for the screen-watchers - this is
          the morning brief you would actually use to plan your day.
        </p>
        <p style={{ color: c.muted, fontSize: 14, lineHeight: 1.6, margin: '12px 0' }}>
          Building now. Will land under the Notches Markets pillar.
        </p>
        <Link to="/notches/dashboard" style={{
          display: 'inline-block', marginTop: 12,
          background: 'transparent', color: c.blue,
          border: `1px solid ${c.blue}`, padding: '6px 14px', borderRadius: 4,
          fontSize: 13, fontWeight: 600, textDecoration: 'none',
        }}>Back to Notches Dashboard</Link>
      </div>
    </div>
  </div>
);

export default MarketsComingSoon;
